/* =========================================================================
   SAMSARA — SECTION-ARTICLE.JS
   Auto-TOC pentru articole cu 3+ headings.
   Inserted la începutul .article-content__body. Smooth-scroll pe click.
   ========================================================================= */

(function () {
  'use strict';

  const body = document.querySelector('.article-content__body');
  if (!body) return;

  const headings = Array.from(body.querySelectorAll('h2')).filter(function (h) {
    // Skip "Continuă lectura" și h2 din final
    const text = (h.textContent || '').toLowerCase();
    return !/continu[aă]\s+lectura/i.test(text);
  });

  if (headings.length < 3) return;

  /* Generate id pe heading dacă lipsește */
  function slugify(s) {
    return String(s).toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  headings.forEach(function (h, i) {
    if (!h.id) {
      h.id = 'cap-' + (i + 1) + '-' + slugify(h.textContent || '').slice(0, 40);
    }
  });

  /* Build TOC element */
  const toc = document.createElement('nav');
  toc.className = 'article-content__toc';
  toc.setAttribute('aria-label', 'Cuprinsul articolului');
  toc.innerHTML = '' +
    '<span class="article-content__toc-eyebrow">Cuprins</span>' +
    '<ol class="article-content__toc-list">' +
      headings.map(function (h, i) {
        const num = String(i + 1).padStart(2, '0');
        return '<li><a href="#' + h.id + '"><span class="article-content__toc-num">' + num + '</span><span class="article-content__toc-text">' + (h.textContent || '').trim() + '</span></a></li>';
      }).join('') +
    '</ol>';

  /* Insert TOC after the first paragraph (intro) */
  const firstP = body.querySelector('p');
  if (firstP && firstP.nextSibling) {
    firstP.parentNode.insertBefore(toc, firstP.nextSibling);
  } else {
    body.insertBefore(toc, body.firstChild);
  }

  /* Smooth scroll + offset for sticky header */
  toc.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      const targetId = a.getAttribute('href').slice(1);
      const target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      const headerOffset = 100;
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + targetId);
    });
  });
})();
